<script>
  import { videoEventHistoryOptions } from '$lib/features/video-meeting/services';
  import { activeCalendarEvent } from '$lib/features/video-meeting/store';
  import { logger } from '$lib/logger';
  import { createQuery } from '@tanstack/svelte-query';
  import { toStore } from 'svelte/store';

  const getPatientStatus = (event) => {
    if (!event) return { message: '', diagnosticData: null };

    switch (event.statusMessage) {
      case 'PATIENT_CLICK_START_MEETING_IN_LOBBY':
        return { message: 'Patienten är redo' };
      case 'PATIENT_CLICK_START_CALL_ON_BANNER':
        return { message: 'Patienten är i lobby' };
      case 'PATIENT_JOINED_MEETING':
        return { message: 'Patienten är ansluten' };
      case 'PATIENT_LEFT_MEETING':
        return { message: 'Patienten har lämnat' };
      case 'PATIENT_CAMERA_OR_MIC_ERROR':
        try {
          const metadata = JSON.parse(event.metadata);
          if (
            metadata.cameraError === 'blocked' &&
            metadata.audioError === 'blocked'
          ) {
            return {
              message: 'Patienten nekade åtkomst till mikrofon och kamera',
            };
          }
        } catch (error) {
          logger.error('Error parsing metadata:', {
            err: error instanceof Error ? error : undefined,
          });
        }
        return { message: 'Fel med patientens kamera eller mikrofon!' };

      default:
        return { message: '' };
    }
  };

  const videoEventHistory = createQuery(
    toStore(() => ({
      ...videoEventHistoryOptions(
        { id: $activeCalendarEvent?.id },
        {
          refetchInterval: 5000, // Refetch every 5 seconds
        },
      ),
      enabled: !!$activeCalendarEvent?.id,
    })),
  );

  let lastPatientStatusEvent = $derived(
    $videoEventHistory?.data
      ? $videoEventHistory.data.findLast(
          (event) =>
            event.statusMessage === 'PATIENT_CLICK_START_MEETING_IN_LOBBY' ||
            event.statusMessage === 'PATIENT_CLICK_START_CALL_ON_BANNER' ||
            event.statusMessage === 'PATIENT_JOINED_MEETING' ||
            event.statusMessage === 'PATIENT_LEFT_MEETING' ||
            event.statusMessage === 'PATIENT_CAMERA_OR_MIC_ERROR',
        )
      : null,
  );

  let lastDiagnosticEvent = $derived(
    $videoEventHistory?.data
      ? $videoEventHistory.data.findLast(
          (event) => event.statusMessage === 'DIAGNOSTIC_COLLECTED',
        )
      : null,
  );

  let { message: statusMessage } = $derived(
    getPatientStatus(lastPatientStatusEvent),
  );
  let diagnosticData = $derived(
    lastDiagnosticEvent ? JSON.parse(lastDiagnosticEvent.metadata) : null,
  );

  let displayMessage = $derived(statusMessage || 'Väntar på patienten...');
</script>

<div class="flex h-2 w-full flex-row justify-between px-4">
  <div class="text-sm font-medium">
    {displayMessage}
  </div>

  {#if diagnosticData}
    <div class="flex flex-row gap-1 text-right text-sm">
      <span>
        <span
          class={`inline-block h-2 w-2 rounded-full ${diagnosticData.dailyWebsocketStatus === 'passed' ? 'bg-emerald-400' : diagnosticData.dailyWebsocketStatus === 'warning' ? 'bg-yellow-400' : 'bg-red-400'} mr-1`}
        ></span>
        Nätverk
      </span>

      <span>
        <span
          class={`inline-block h-2 w-2 rounded-full ${diagnosticData.cameraPermission === 'granted' ? 'bg-emerald-400' : 'bg-red-400'} mr-1`}
        ></span>
        Kamera
      </span>
      <span>
        <span
          class={`inline-block h-2 w-2 rounded-full ${diagnosticData.microphonePermission === 'granted' ? 'bg-emerald-400' : 'bg-red-400'} mr-1`}
        ></span>
        Mikrofon
      </span>
    </div>
  {/if}
</div>
